import { StoreDrawer } from "./../_module/_click/storeDrawer";
import { windowSize } from "./../_module/windowSize";
import { SwiperContainer } from "./../_module/_carousel/swiper";
import { Opening } from "./../_module/_animation/opening";
import { LetterMotion } from "./../_module/_text/letterMotion";

import { Locomo } from "./../_module/_scroll/locomo";

export const Product = {
  /**
   * funcs
   */
  init: () => {
    StoreDrawer.init()
    SwiperContainer.init();
    // SwiperContainer.productKeyVisual();
    Opening.lowPageReady()
    Product.productAutoCarousel()
    setTimeout(()=>{
      Product.productKeyVisual();
    },400)
    
    LetterMotion.init(true)

    setTimeout(()=>{
      Locomo.update();
    },300)
    
  },
  productAutoCarousel:()=>{
    let carousel=document.querySelector(".carousel-auto");
    let storyContainer=document.querySelector(".story-container");
    for (let i = 0,li=2;i<li;i++){
      let clone=storyContainer.cloneNode(true);
      // carousel.insertBefore(clone,storyContainer)
      carousel.appendChild(clone)
    }
    carousel.style.width=windowSize.clientSize().W*3 + "px";
    // document.querySelectorAll(".story-container").forEach(function(item){
    //   let sliderWidth=windowSize.clientSize().W;
    //   let clone=item.cloneNode(true);
    //   carousel.insertBefore(clone,storyContainer)
    //   carousel.insertBefore(clone, storyContainer.nextElementSibling);
    //   carousel.style.width=sliderWidth*3;
    // })


    // $('.story-container').each(function(){
    //   var sliderWidth = $(this).width();
 
    //   $(this).clone(true).insertBefore(this);
    //   $(this).clone(true).insertAfter(this);
 
    //   $('.carousel-auto').css('width', sliderWidth*3); // 親要素の横幅を子要素の３倍にする
    // });
  },
  productKeyVisual:()=>{
    Product.prodItem=document.querySelectorAll('.productKv-item')

    let C=1;
    let len=Product.prodItem.length;
    
    if(len<=1) {
      Product.prodItem[0].classList.add('is-solo')
      return;
    }
    else{
      Product.prodItem[0].classList.add('is-active')
    }

    Product.timer=setInterval(() => {
      Product.prodItem.forEach(function(el){
        el.classList.remove('is-active')
      })
      
      Product.prodItem[C].classList.add('is-active')
      C++;
      if(len==C){
        C=0;
      }
    }, 7000);
  },
  cancelProductKeyVisual:()=>{
    // console.log("cancel")
    clearInterval(Product.timer);
  }
};
